import { render, staticRenderFns } from "./news-article.vue?vue&type=template&id=ba6e79c8&scoped=true"
import script from "./news-article.vue?vue&type=script&lang=js"
export * from "./news-article.vue?vue&type=script&lang=js"
import style0 from "./news-article.vue?vue&type=style&index=0&id=ba6e79c8&prod&lang=scss&scoped=true"
import style1 from "./news-article.vue?vue&type=style&index=1&id=ba6e79c8&prod&lang=scss"
import style2 from "./news-article.vue?vue&type=style&index=2&id=ba6e79c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6e79c8",
  null
  
)

export default component.exports